import React from 'react';
import { FileZipFilled, FileOutlined, CloseCircleFilled } from '@ant-design/icons';

export const FileUploadPreview = ({ file, handleDelete }) => {
    const formatFileSize = (bytes) => {
        const KB = 1024;
        const MB = KB * 1024;
        if (bytes < KB) return `${bytes} B`;
        if (bytes < MB) return `${(bytes / KB).toFixed(0)} KB`;
        return `${(bytes / MB).toFixed(2)} MB`;
    };

    return (
        <div className="file-upload-preview">
            <div>
                <FileZipFilled style={{ color: 'var(--yellow-default)', fontSize: '2rem' }} />
            </div>
            <div className="file-info">
                <span>{file.name}</span>
                <span>{formatFileSize(file.size)}</span>
            </div>
            <CloseCircleFilled className="close-icon" onClick={handleDelete} />
        </div>
    );
};
